export default ($translateProvider) => {
    $translateProvider.useStaticFilesLoader({
        prefix: 'languages/',
        suffix: `.json?v=${SEED_CORE.REVISION}`
    });
    $translateProvider.preferredLanguage('et');
    $translateProvider.registerAvailableLanguageKeys(['en', 'et', 'lv', 'lt', 'ru', 'no', 'fi', 'sv'], {
        '*': 'en' // all not defined available language keys will fallback to en in case no json file exists
    });
    $translateProvider.useSanitizeValueStrategy(null);
    $translateProvider.useMessageFormatInterpolation();
};



// WEBPACK FOOTER //
// ./src/app/configs/translate/index.js